import { OPOSICIONES_BASIC_PLAN } from './oposicionesAccess';

type AuthIntent = 'funcionario' | 'opositor' | null | undefined;

interface AuthRouteInput {
  plan?: string | null;
  opositorBody?: string | null;
  intent?: AuthIntent;
}

interface AccessProfile {
  role?: string | null;
  is_betatester?: boolean | null;
}

const BODY_TO_ROUTE: Record<string, string> = {
  secretaria: '/app/oposiciones/chat',
  c1: '/app/oposiciones-c1/chat',
  c2: '/app/oposiciones-c2/chat',
  ayudante_iipp: '/app/oposiciones-iipp/chat',
  iipp: '/app/oposiciones-iipp/chat',
  guardia_civil: '/app/guardia-civil/chat',
  policia_nacional: '/app/policia-nacional/chat',
  generico: '/app/base-comun/chat',
};

const PLAN_TO_ROUTE: Record<string, string> = {
  [OPOSICIONES_BASIC_PLAN]: '/app/oposiciones/chat',
  base_comun: '/app/base-comun/chat',
  oposiciones: '/app/oposiciones/chat',
  oposiciones_c1: '/app/oposiciones-c1/chat',
  oposiciones_c2: '/app/oposiciones-c2/chat',
  oposiciones_iipp: '/app/oposiciones-iipp/chat',
  oposiciones_guardia_civil: '/app/guardia-civil/chat',
  oposiciones_policia_nacional: '/app/policia-nacional/chat',
  oposiciones_generico: '/app/base-comun/chat',
};

export function resolvePostAuthRoute({ plan, opositorBody, intent }: AuthRouteInput): string {
  if (opositorBody && BODY_TO_ROUTE[opositorBody]) {
    return BODY_TO_ROUTE[opositorBody];
  }

  if (plan && PLAN_TO_ROUTE[plan]) {
    return PLAN_TO_ROUTE[plan];
  }

  if (intent === 'opositor') {
    return '/app/oposiciones/chat';
  }

  if (intent === 'funcionario') {
    return '/app/funcionarios';
  }

  return '/app/chat';
}

export function getOpositorPlan(opositorBody?: string | null): string {
  switch (opositorBody) {
    case 'c1':
      return 'oposiciones_c1';
    case 'c2':
      return 'oposiciones_c2';
    case 'ayudante_iipp':
    case 'iipp':
      return 'oposiciones_iipp';
    case 'guardia_civil':
      return 'oposiciones_guardia_civil';
    case 'policia_nacional':
      return 'oposiciones_policia_nacional';
    case 'generico':
      return 'base_comun';
    case 'secretaria':
    default:
      return 'oposiciones';
  }
}

export function hasFullAppAccess(profile?: AccessProfile | null): boolean {
  return Boolean(profile?.is_betatester || profile?.role === 'super_admin');
}
